import dayjs from 'dayjs';

export const DEFAULT_MAX_ADVANCE_BOOKING_MONTHS = 12;
export const VHI_MAX_ADVANCE_BOOKING_MONTHS = 48;

export function getMaxBookingDate(
	maxAdvanceBookingMonths?: number,
	isVhi = false,
): Date {
	const months = isVhi
		? VHI_MAX_ADVANCE_BOOKING_MONTHS
		: (maxAdvanceBookingMonths ?? DEFAULT_MAX_ADVANCE_BOOKING_MONTHS);

	return dayjs().add(months, 'month').toDate();
}

export function clampToMaxBookingDate(
	maxDate: Date | undefined,
	maxAdvanceBookingMonths?: number,
): Date {
	const maxBookingDate = getMaxBookingDate(maxAdvanceBookingMonths);

	return maxDate && dayjs(maxDate).isBefore(maxBookingDate)
		? maxDate
		: maxBookingDate;
}
